// import { emailENUM } from "@/erp/sale/asesor";
import {
  TipoFormaPagoEnumChoice,
} from "@/shared";
import {
  useFetchEntidadesFinancieras,
} from "@/shared/actions/erp";
import { useFetchCooperativa } from "@/shared/actions/erp/cooperativa.actions";
// import { useLocalidad } from "@/shared/hooks/useLocalidad";
import {
  EntidadesFinancieras,
  IPaymentMethod,
  PaymentMethodEnum,
  TipoContratoENUM,
} from "@/shared/interfaces";
import {
  IPaymentMethodV2,
  TipoPagoV2Enum,
} from "@/shared/interfaces/erp/system-settings";
import { getPaymentMethodsV2 } from "@/shared/actions/erp";
import CardValidator from "card-validator";
import { useEffect, useState } from "react";


interface useFormaPagoProps {
    form: any,
    formaPagoDataContainer?: any
}



export const useFormaPago = ({
    form,
    formaPagoDataContainer
}: useFormaPagoProps) => {

  ///* state
  const [tipoTarjeta, setTipoTarjeta] = useState<string | null>(null);
  // V2 - 3 niveles de pago
  const [entidadesV2Filtradas, setEntidadesV2Filtradas] = useState<EntidadesFinancieras[]>([]);
  const [isLoadingEntidadesV2, setIsLoadingEntidadesV2] = useState<boolean>(false);
  const [formasPagoV2Filtradas, setFormasPagoV2Filtradas] = useState<IPaymentMethodV2[]>([]);
  const [isLoadingFormasPagoV2, setIsLoadingFormasPagoV2] = useState<boolean>(false);
  const [selectedCardTypeName, setSelectedCardTypeName] = useState<string | null>(null);




    const { reset, setError, clearErrors } = form;

    const { data: dataCooperativa, isLoading: isLoadingCooperativa } = useFetchCooperativa({
        params: {
        entidad_financiera: form.watch("entidad_financiera")!,
        estado: true,
        },
        enabled: !!form.watch("entidad_financiera"),
    });

    const handleValidarTarjeta = (numeroTarjeta: string) => {
        const numberValidation = CardValidator.number(numeroTarjeta);

        // Detectar tipo de tarjeta de forma reactiva (incluso con números parciales)
        if (numberValidation.card) {
            setTipoTarjeta(numberValidation.card.type);

            // Validar que el tipo de tarjeta coincida con el seleccionado - REACTIVO
            if (selectedCardTypeName) {
                const expectedCardType = cardTypeMapping[selectedCardTypeName];
                const detectedCardType = numberValidation.card.type;

                if (expectedCardType && detectedCardType !== expectedCardType) {
                setError("numero_tarjeta", {
                    message: `Debe ingresar una tarjeta ${selectedCardTypeName}. Se detectó: ${numberValidation.card.niceType}`,
                });
                return;
                }
            }
        } else {
        setTipoTarjeta("");
        }

        // Validar formato completo solo si tiene suficientes dígitos
        if (numeroTarjeta.length >= 13) {
            if (!numberValidation.isValid) {
                const mensajeError = selectedCardTypeName
                ? `Ingrese un número de tarjeta válido para: ${selectedCardTypeName}`
                : "Ingresar una tarjeta válida";
                setError("numero_tarjeta", {
                message: mensajeError,
                });
                return;
            }
        }

        clearErrors("numero_tarjeta");
    };

    // ============ V2 - 3 niveles de pago ============

    // Handler para cuando cambia el Tipo de Pago (DÉBITO/CRÉDITO/RECAUDACIÓN)
    const handleTipoPagoV2Change = async (tipoPago: TipoPagoV2Enum) => {
        setTipoTarjeta(null);

        // Guardar el plan actual ANTES del reset para usarlo después
        // const currentPlan = form.getValues().plan;

        // Determinar forma_pago según tipo
        let formaPagoValue: string = "";
        if (tipoPago === TipoPagoV2Enum.DEBITO) {
            formaPagoValue = PaymentMethodEnum.DEBITO;
        } else if (tipoPago === TipoPagoV2Enum.CREDITO) {
            formaPagoValue = PaymentMethodEnum.TARJETA;
        } else if (tipoPago === TipoPagoV2Enum.RECAUDACION) {
            formaPagoValue = TipoFormaPagoEnumChoice.RECAUDACION;
        }

        // Limpiar formulario
        reset({
            ...form.getValues(),
            tipo_pago_v2: tipoPago,
            entidad_financiera: "",
            forma_pago_v2:
                tipoPago === TipoPagoV2Enum.RECAUDACION ? "RECAUDACIÓN" : "", // Para RECAUDACIÓN, setear directamente
            codigo_forma_pago:
                tipoPago === TipoPagoV2Enum.RECAUDACION ? "RECAUDACIÓN" : "",
            forma_pago: formaPagoValue,
            tipo_contrato:
                tipoPago === TipoPagoV2Enum.RECAUDACION
                ? TipoContratoENUM.GEDATECU
                : "",
            tarjeta: "",
            valor_instalacion_total: "",
            valor_instalacion: "",
            valor_instalacion_iva: "",
            numero_cuenta: "",
            tipo_cuenta_bancaria: "",
            numero_tarjeta: "",
            tarjeta_fecha_caducidad: null,
            observacion_1:
                tipoPago === TipoPagoV2Enum.RECAUDACION
                ? "APLICA PARA TODAS LAS CIUDADES"
                : "",
            cooperativa: "",
        });

        // Para RECAUDACIÓN, no cargar entidades ni formas de pago
        if (tipoPago === TipoPagoV2Enum.RECAUDACION) {
            setEntidadesV2Filtradas([]);
            setFormasPagoV2Filtradas([]);
            // Calcular valor instalación si hay plan seleccionado
            // if (currentPlan) {
            //     handleValorInstalacion();
            //     // Pasar "RECAUDACIÓN" como codigo_forma_pago explícitamente
            //     await aplicaPromocion(currentPlan, "RECAUDACIÓN");
            // }
            return;
        }

        // Cargar entidades filtradas por tipo de pago (solo para DÉBITO y CRÉDITO)
        if (tipoPago) {
            setIsLoadingEntidadesV2(true);
            try {
                const res = await getPaymentMethodsV2({
                tipo_pago: tipoPago,
                aplica_home: true,
                estado: true,
                filterByState: false,
                page_size: 1000,
                });

                // Obtener entidades únicas de las formas de pago V2
                const entidadesUnicas = new Map<string, EntidadesFinancieras>();
                res.data.data.forEach((fp: IPaymentMethodV2) => {
                if (!entidadesUnicas.has(fp.entidad_financiera)) {
                    entidadesUnicas.set(fp.entidad_financiera, {
                    codigo: fp.entidad_financiera,
                    nombre: fp.entidad_financiera, // Se usará el código como nombre
                    } as EntidadesFinancieras);
                }
                });

                setEntidadesV2Filtradas(Array.from(entidadesUnicas.values()));
                setFormasPagoV2Filtradas([]);
            } catch (error) {
                console.error("Error cargando entidades V2:", error);
                setEntidadesV2Filtradas([]);
            } finally {
                setIsLoadingEntidadesV2(false);
            }
        }
    };

    // Handler para cuando cambia la Entidad Bancaria
    const handleEntidadV2Change = async (entidadCodigo: string) => {
        // Limpiar forma de pago al cambiar entidad
        reset({
            ...form.getValues(),
            entidad_financiera: entidadCodigo,
            forma_pago_v2: "",
            codigo_forma_pago: "",
            numero_cuenta: "",
            tipo_cuenta_bancaria: "",
            numero_tarjeta: "",
            tarjeta_fecha_caducidad: null,
            valor_instalacion_total: "",
            valor_instalacion: "",
            valor_instalacion_iva: "",
            cooperativa: "",
        });

        // Cargar formas de pago filtradas
        if (entidadCodigo && form.getValues().tipo_pago_v2) {
            setIsLoadingFormasPagoV2(true);
            try {
                const res = await getPaymentMethodsV2({
                tipo_pago: form.getValues().tipo_pago_v2 as TipoPagoV2Enum,
                entidad_financiera: entidadCodigo,
                aplica_home: true,
                estado: true,
                filterByState: false,
                page_size: 1000,
                });

                let formasPagoFiltradas = res.data.data;

                // Filtro especial para COOP JEP + DÉBITO: solo mostrar "Cuenta de Ahorros"
                // Para CRÉDITO se muestran todas las opciones (Visa, Mastercard, etc.)
                const tipoPagoActual = form.getValues().tipo_pago_v2;
                if (
                entidadCodigo.toUpperCase().includes("JEP") &&
                tipoPagoActual === TipoPagoV2Enum.DEBITO
                ) {
                    formasPagoFiltradas = formasPagoFiltradas.filter(
                        (fp: IPaymentMethodV2) =>
                        fp.nombre.toLowerCase().includes("ahorro"),
                    );
                }

                setFormasPagoV2Filtradas(formasPagoFiltradas);
            } catch (error) {
                console.error("Error cargando formas de pago V2:", error);
                setFormasPagoV2Filtradas([]);
            } finally {
                setIsLoadingFormasPagoV2(false);
            }
        }
    };

    // Función auxiliar para mapear nombre de forma de pago a tipo de cuenta bancaria
    const mapFormaPagoToTipoCuenta = (nombreFormaPago: string): string => {
        const nombreLower = nombreFormaPago.toLowerCase();
        if (nombreLower.includes("amiga")) return "AMIGA";
        if (nombreLower.includes("corriente")) return "CORRIENTE";
        if (nombreLower.includes("ahorro")) return "AHORRO";
        return ""; // Por defecto vacío si no coincide
    };

    // Handler para cuando se selecciona una Forma de Pago V2
    const handleFormaPagoV2Change = async (formaPago: IPaymentMethodV2) => {
        setTipoTarjeta(null);
        setSelectedCardTypeName(null);

        if (!formaPago) {
            reset({
                ...form.getValues(),
                forma_pago_v2: "",
                codigo_forma_pago: "",
            });
            return;
        }

        // Guardar el plan actual ANTES del reset para usarlo después
        // const currentPlan = form.getValues().plan;

        // Guardar el nombre del tipo de tarjeta si es CRÉDITO
        if (formaPago.tipo_pago === TipoPagoV2Enum.CREDITO) {
            setSelectedCardTypeName(formaPago.nombre);
        }

        // Mapeo automático de tipo_cuenta_bancaria basado en el nombre de la forma de pago (solo para DÉBITO)
        const tipoCuentaAutomatico =
        formaPago.tipo_pago === TipoPagoV2Enum.DEBITO
            ? mapFormaPagoToTipoCuenta(formaPago.nombre)
            : "";

        reset({
            ...form.getValues(),
            forma_pago_v2: formaPago.codigo,
            codigo_forma_pago: formaPago.codigo,
            forma_pago: formaPago?.forma_pago_legacy,
            forma_pago_legacy: formaPago.forma_pago_legacy || null, // Mapeo a V1 para compatibilidad
            tarjeta: formaPago.forma_pago_legacy_data?.tarjeta 
                ?? formaPago?.nombre?.toUpperCase()
                ?? null, // Tarjeta desde V1 legacy
            tipo_contrato: TipoContratoENUM.GEDATECU,
            no_cobrar: false,
            numero_cuenta: "",
            tipo_cuenta_bancaria: tipoCuentaAutomatico, // Mapeo automático basado en el nombre de la forma de pago
            numero_tarjeta: "",
            observacion_1: "APLICA PARA TODAS LAS CIUDADES",
        });

        // Calcular valor instalación
        // handleValorInstalacion();

        // Aplicar promoción si hay plan seleccionado
        // Pasar el codigo_forma_pago explícitamente porque form.getValues() no tiene el valor actualizado inmediatamente después del reset
        // if (currentPlan) {
        // await aplicaPromocion(currentPlan, formaPago.codigo);
        // }
    };

    const { data: dataEntidadFinanciero, isLoading: isLoadingEntidadFinanciero } =
    useFetchEntidadesFinancieras({
      page_size: 600,
      enabled: form.watch("forma_pago") == PaymentMethodEnum.TARJETA,
    });

  

    const handleFormaPago = async (e: IPaymentMethod) => {
        setTipoTarjeta(null);

        // Guardar el plan actual ANTES del reset
        // const currentPlan = form.getValues().plan;

        reset({
            ...form.getValues(),
            entidad_financiera: null,
            codigo_forma_pago: "",
            tipo_contrato: "",
            tarjeta: "",
            valor_instalacion_total: "",
            valor_instalacion: "",
            valor_instalacion_iva: "",
            numero_cuenta: "",
            tipo_cuenta_bancaria: "",
            numero_tarjeta: "",
            observacion_1: "",
            forma_pago: "",
        });

        if (!e) return;

        if (e.forma_pago == TipoFormaPagoEnumChoice.DEBITO)
            form.setValue("entidad_financiera", e.entidad_financiera);

        reset({
            ...form.getValues(),
            no_cobrar: false,
            forma_pago: e.forma_pago,
            codigo_forma_pago: e.codigo,
            tipo_contrato: e.tipo_contrato ?? TipoContratoENUM.GEDATECU,
            tarjeta: e.tarjeta,
            numero_cuenta: "",
            tipo_cuenta_bancaria: "",
            numero_tarjeta: "",
            observacion_1: "APLICA PARA TODAS LAS CIUDADES",
            tipo_plan: form.getValues().tipo_plan,
            tarjeta_fecha_caducidad:
                e.forma_pago !== PaymentMethodEnum.TARJETA
                ? null
                : form.getValues().tarjeta_fecha_caducidad,
        });

        // handleValorInstalacion();

        // // Pasar el codigo_forma_pago explícitamente
        // if (currentPlan) {
        // await aplicaPromocion(currentPlan, e.codigo);
        // }
    };




  // Mapeo de nombres de tarjeta a tipos de card-validator
  const cardTypeMapping: Record<string, string> = {
    Visa: "visa",
    Mastercard: "mastercard",
    Discover: "discover",
    Diners: "diners-club",
  };


  const loadFormaPagoData = async() =>{
    reset({
        ...form.getValues(),
        forma_pago: formaPagoDataContainer?.forma_pago,
        codigo_forma_pago: formaPagoDataContainer?.forma_pago_data?.codigo,
        // V2 - Cargar datos de pago V2 si existen
        tipo_pago_v2: formaPagoDataContainer?.tipo_pago_v2 ?? "",
        entidad_financiera: formaPagoDataContainer?.entidad_financiera ?? "",
        forma_pago_v2: formaPagoDataContainer?.forma_pago_v2 ?? "RECAUDACIÓN", // Para mantener compatibilidad con preventas antiguas que solo tenían forma_pago_legacy
        forma_pago_legacy: formaPagoDataContainer?.forma_pago_v2_data?.forma_pago_legacy ?? null,
        tarjeta: formaPagoDataContainer?.forma_pago_v2_data?.forma_pago_legacy_data?.tarjeta ?? formaPagoDataContainer?.tarjeta ??
        null,
    } as any);

    // V2: Si hay tipo_pago_v2, cargar las opciones de entidades y formas de pago
    if (formaPagoDataContainer?.tipo_pago_v2) {
        // Cargar entidades (sin hacer reset del formulario)
        setIsLoadingEntidadesV2(true);
        try {
            const res = await getPaymentMethodsV2({
                tipo_pago: formaPagoDataContainer.tipo_pago_v2 as TipoPagoV2Enum,
                aplica_home: true,
                estado: true,
                filterByState: false,
                page_size: 1000,
            });

            const entidadesUnicas = new Map<string, EntidadesFinancieras>();
            res.data.data.forEach((fp: IPaymentMethodV2) => {
                if (!entidadesUnicas.has(fp.entidad_financiera)) {
                entidadesUnicas.set(fp.entidad_financiera, {
                    codigo: fp.entidad_financiera,
                    nombre: fp.entidad_financiera,
                } as EntidadesFinancieras);
                }
            });
            setEntidadesV2Filtradas(Array.from(entidadesUnicas.values()));

            // Si hay entidad seleccionada, cargar las formas de pago
            if (formaPagoDataContainer.entidad_financiera) {
                const resFP = await getPaymentMethodsV2({
                    tipo_pago: formaPagoDataContainer.tipo_pago_v2 as TipoPagoV2Enum,
                    entidad_financiera: formaPagoDataContainer.entidad_financiera,
                    aplica_home: true,
                    estado: true,
                    filterByState: false,
                    page_size: 1000,
                });
                setFormasPagoV2Filtradas(resFP.data.data);
            }
        } catch (error) {
            console.error("Error cargando datos V2 para edición:", error);
        } finally {
            setIsLoadingEntidadesV2(false);
        }
    }
  }

  useEffect(()=>{
    if(formaPagoDataContainer?.forma_pago_data){
        loadFormaPagoData();
    }
  },[])




  return {
    handleFormaPago,
    dataCooperativa: dataCooperativa?.data.data,
    isLoadingCooperativa,
    handleValidarTarjeta,
    tipoTarjeta,
    isLoadingEntidadFinanciero,
    dataEntidadFinanciero,
    handleTipoPagoV2Change,
    handleEntidadV2Change,
    handleFormaPagoV2Change,
    entidadesV2Filtradas,
    isLoadingEntidadesV2,
    formasPagoV2Filtradas,
    isLoadingFormasPagoV2
  };
};
